module.exports = __webpack_public_path__ + "static/siplologo-c63dce09c3330b11a80c58326cde8ebb.png";